import { defineComponent as $, ref as S, computed as h, onMounted as E, h as i, Transition as A } from "vue";
import w from "./ghl-ui.es890.js";
import { useRtl as z } from "./ghl-ui.es851.js";
import N from "./ghl-ui.es854.js";
import b from "./ghl-ui.es855.js";
import { isSlotEmpty as O, resolveSlot as P } from "./ghl-ui.es860.js";
import { createKey as T } from "./ghl-ui.es384.js";
import { useThemeClass as L } from "./ghl-ui.es857.js";
import { color2Class as V } from "./ghl-ui.es885.js";
import { getTitleAttribute as j } from "./ghl-ui.es891.js";
import M from "./ghl-ui.es892.js";
import Z from "./ghl-ui.es893.js";
import D from "./ghl-ui.es894.js";
const F = Object.assign(Object.assign({}, b.props), {
  value: [String, Number],
  max: Number,
  dot: Boolean,
  type: {
    type: String,
    default: "default"
  },
  show: {
    type: Boolean,
    default: !0
  },
  showZero: Boolean,
  processing: Boolean,
  color: String,
  offset: Array
}), ee = $({
  name: "Badge",
  props: F,
  setup(e, {
    slots: t
  }) {
    const {
      mergedClsPrefixRef: n,
      inlineThemeDisabled: f,
      mergedRtlRef: a
    } = N(e), d = b("Badge", "-badge", w, Z, e, n), u = S(!1), y = () => {
      u.value = !0;
    }, B = () => {
      u.value = !1;
    }, p = h(() => e.show && (e.dot || e.value !== void 0 && !(!e.showZero && Number(e.value) <= 0) || !O(t.value)));
    E(() => {
      p.value && (u.value = !0);
    });
    const m = z("Badge", a, n), g = h(() => {
      const {
        type: r,
        color: o
      } = e, {
        common: {
          cubicBezierEaseInOut: s,
          cubicBezierEaseOut: v
        },
        self: {
          [T("color", r)]: c,
          fontFamily: x,
          fontSize: C
        }
      } = d.value;
      return {
        "--n-font-size": C,
        "--n-font-family": x,
        "--n-color": o || c,
        "--n-ripple-color": o || c,
        "--n-bezier": s,
        "--n-ripple-bezier": v
      };
    }), l = f ? L("badge", h(() => {
      let r = "";
      const {
        type: o,
        color: s
      } = e;
      return o && (r += o[0]), s && (r += V(s)), r;
    }), g, e) : void 0, R = h(() => {
      const {
        offset: r
      } = e;
      if (!r)
        return;
      const [o, s] = r, v = typeof o == "number" ? `${o}px` : o, c = typeof s == "number" ? `${s}px` : s;
      return {
        transform: `translate(calc(${m != null && m.value ? "50%" : "-50%"} + ${v}), ${c})`
      };
    });
    return {
      rtlEnabled: m,
      mergedClsPrefix: n,
      appeared: u,
      showBadge: p,
      handleAfterEnter: y,
      handleAfterLeave: B,
      cssVars: f ? void 0 : g,
      themeClass: l == null ? void 0 : l.themeClass,
      onRender: l == null ? void 0 : l.onRender,
      offsetStyle: R
    };
  },
  render() {
    var e;
    const {
      mergedClsPrefix: t,
      onRender: n,
      themeClass: f,
      $slots: a
    } = this;
    n == null || n();
    const d = (e = a.default) === null || e === void 0 ? void 0 : e.call(a);
    return i("div", {
      class: [`${t}-badge`, this.rtlEnabled && `${t}-badge--rtl`, f, {
        [`${t}-badge--dot`]: this.dot,
        [`${t}-badge--as-is`]: !d
      }],
      style: this.cssVars
    }, d, i(A, {
      name: "fade-in-scale-up-transition",
      onAfterEnter: this.handleAfterEnter,
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => this.showBadge ? i("sup", {
        class: `${t}-badge-sup`,
        title: j(this.value),
        style: this.offsetStyle
      }, P(a.value, () => [this.dot ? null : i(D, {
        clsPrefix: t,
        appeared: this.appeared,
        max: this.max,
        value: this.value
      })]), this.processing ? i(M, {
        clsPrefix: t
      }) : null) : null
    }));
  }
});
export {
  F as badgeProps,
  ee as default
};
